// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1qWSK","ranges":"BmiRanges_ranges__1HbwM"};